import { render, staticRenderFns } from "./DateItem.vue?vue&type=template&id=0b1cc4f7"
import script from "./DateItem.vue?vue&type=script&lang=js"
export * from "./DateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports